import React from 'react';
import { TeamPermission } from 'nekst-api';
import DetailsFieldGroupsList from './DetailsFieldGroupsList';
import AccessChecker from '../../../shared/authorization/AccessChecker';
import { SettingsBreadcrumbs } from '../../settingsModule';
import { Breadcrumb } from '../../../shared/web/layout/Breadcrumbs';

export default function DetailsFieldGroupsPage() {
  return (
    <AccessChecker permissionToCheck={TeamPermission.MANAGE_PORTAL}>
      <SettingsBreadcrumbs>
        <Breadcrumb text="Details Boxes Groups" />
      </SettingsBreadcrumbs>
      <DetailsFieldGroupsList />
    </AccessChecker>
  );
}
